module.exports = __webpack_public_path__ + "static/4HOVER-d14a32ae91fbd331aee9aba7992114e4.png";